const menus = [
  {
    menuCode: 'tapir-md',
    menuName: 'Tapir MD',
    menuLongName: 'マーケット・セグメンテーション',
    description:
      'マーチャンダイザー（MD）向けTapir。\n・指定の商品群を買い回りグループにセグメンテーションします。\n・商品相互の関連から”並び順”を振ります。\n・商品にMD指向の”採用順”を振ります。\n商品カット、棚割等、MDの意思決定を支援します。',
    imageUrl:
      'https://storage.googleapis.com/c3lab-common_public/bizoope/giggle/images/menu/tapir-md.jpg',
  },
  {
    menuCode: 'tapir-mk',
    menuName: 'Tapir MK',
    menuLongName: 'マーケット・セグメンテーション',
    description:
      'マーケター（MK）向けTapir。\n・指定の商品群／分類群を買い回りグループにセグメンテーションします。\n・商品／分類相互の関連から”並び順”を振ります。\n・商品／分類にMK指向の”採用順”を振ります。\n販促、クーポン、フロアレイアウト等、MKの意思決定を支援します。',
    imageUrl:
      'https://storage.googleapis.com/c3lab-common_public/bizoope/giggle/images/menu/tapir-mk.jpg',
  },
]

export default {
  async get() {
    return menus
  },
}
